import React, { memo } from 'react';
import { Typography } from '@mui/material';
import { timeConverter } from '../../../utils/utils';
import { Message } from '../../../type/chat.types';

type MessageTimeProps = {
    message: Message;
    isMe: boolean;
};

const MessageTime = ({ message, isMe }: MessageTimeProps) => {
    return (
        <Typography
            variant="caption"
            component="span"
            sx={{
                display: 'block',
                alignSelf: isMe ? 'flex-end' : 'flex-start',
                color: 'text.disabled',
                mt: 0.45,
                fontSize: 9.5,
                lineHeight: 1.2,
                fontFamily: 'IRANSans',
                whiteSpace: 'nowrap',
            }}>
            {timeConverter(message?.created_at, 'time')}
        </Typography>
    );
};

export default memo(MessageTime);
